export const GET_CONTACT_NOTES_BY_PAGE = "GET_CONTACT_NOTES_BY_PAGE";
export const SET_CONTACT_NOTES_BY_PAGE = "SET_CONTACT_NOTES_BY_PAGE";
export const POST_NEW_NOTE = "POST_NEW_NOTE";
export const ADD_NEW_NOTE = "ADD_NEW_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const REMOVE_NOTE = "REMOVE_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const SET_UPDATED_NOTE = "SET_UPDATED_NOTE";
